import { UAParser } from 'ua-parser-js'

// 蔵クラWebがサポートしてるブラウザ
const kcloudWebSupportBrowsers = [
  "Chrome",
  "Edge",
]

/**
 * uaParserインスタンスを返す. uaArgの指定があればそのuaParser
 * ない場合は、実行環境のuaParser
 * @param uaArg user-agent(省略可)
 * @returns uaParserインスタンス
 */
const uaParserResult = (uaArg?: string) => {
  // 指定がなければデフォルトのuaParser
  if(!uaArg) return new UAParser().getResult()

  const parser = new UAParser(uaArg).getResult()
  return parser
}

/**
 * platformNamesのブラウザ名に含まれるかどうかを返す。
 * @param platformNames 
 * @param uaArg user-agent(省略可)
 * @returns 
 */
export const isBrowser = (platformNames: string[], uaArg?: string) => {
  const parser = uaParserResult(uaArg)
  if (!parser) return false;
  if (!parser.browser.name) return false;

  return platformNames.includes(parser.browser.name);
}

/**
 * 蔵クラWebがサポートしてるブラウザかどうかを返す.
 * @param uaArg user-agent(省略可)
 * @returns 
 */
export const isKcloudWebSupportBrowser = (uaArg?: string) => {
  return isBrowser(kcloudWebSupportBrowsers, uaArg)
}


/**
 * 表示用のブラウザ名を返す
 * @param uaArg user-agent(省略可)
 * @returns 
 */
export const displayBrowserName = (uaArg?: string) => {
  const parser = uaParserResult(uaArg)
  if (!parser) return null;
  if (!parser.browser.name) return null;
  return parser.browser.name;
}

/**
 * iPhone の UserAgent かどうかを返す.
 * @param uaArg user-agent(省略可)
 * @returns 
 */
export const isIphoneUa = (uaArg?: string) => {
  const parser = uaParserResult(uaArg)
  if(!parser) return false;

  if(parser.device.model === 'iPhone') return true;

  return false;
}

/**
 * iPad の UserAgent かどうかを返す.
 * @param uaArg user-agent(省略可)
 * @returns 
 */
export const isIpadUa = (uaArg?: string) => {
  const parser = uaParserResult(uaArg)
  if(!parser) return false;

  if(parser.device.model === 'iPad') return true;

  if(parser.ua){
    if(parser.ua.toLowerCase().includes('macintosh') && 'ontouchend' in window.document) {
      // iPad OS13(デスクトップ用Webサイトを表示:On設定時)
      // https://www.qam-web.com/?p=15115
      return true;
    }
  }
  return false;
}

/**
 * iOS の UserAgent かどうかを返す.
 * @param uaArg user-agent(省略可)
 * @returns 
 */
export const isIosUa = (uaArg?: string) => {
  if(isIphoneUa(uaArg)) return true;
  if(isIpadUa(uaArg)) return true;

  const parser = uaParserResult(uaArg)
  if(!parser) return false;

  if(parser.os && parser.os.name === 'iOS') return true;

  return false;
}

/**
 * iOS 以外の UserAgent かどうかを返す.
 * @param uaArg user-agent(省略可)
 * @returns 
 */
export const isNoIosUa = (uaArg?: string) => {
  return !isIosUa(uaArg);
}

/**
 * Android の UserAgent かどうかを返す.
 * @param uaArg user-agent(省略可)
 * @returns 
 */
 export const isAndroidUa = (uaArg?: string) => {
  const parser = uaParserResult(uaArg)
  if(!parser) return false;

  if(parser.os && parser.os.name === 'Android') return true;

  return false;
}

/**
 * デスクトップOSの UserAgent かどうかを返す.
 * @param {string?} uaArg user-agent(省略可)
 * @returns 
 */
 export const isDesktopUa = (uaArg?: string) => {
  const parser = uaParserResult(uaArg)
  if(!parser) return false;

  const desktopOsNames = ['Windows', 'macOS', 'Chrome OS', 'Linux'];

  const osName = ((parser.os && parser.os.name) || '');
  
  const hit = desktopOsNames.find(n => {
    return osName.startsWith(n);
  })
  return !!hit;
}

